import { fieldError } from '../fieldError';

export function checkMaxLength(maxLengthValue) {
  return value =>
    value.length > maxLengthValue
      ? fieldError(`Insira no máximo ${maxLengthValue} caracteres`)
      : null;
}
